import { useMemo } from "react";
import ReactCountryFlag from "react-country-flag";
// @mui
import {
  Box,
  Grid,
  IconButton,
  LinearProgress,
  Tooltip,
  Typography,
} from "@mui/material";
import Iconify from "~src/components/Iconify";

// -----------------------------------------------------------------------------------

export default function CountryDetails({
  data,
  tooltip,
}: {
  data: {
    established: { id: string; value: number }[];
    growing: { id: string; value: number }[];
    opportunity: { id: string; value: number }[];
  };
  tooltip: string;
}) {
  const combinedData = useMemo(() => {
    return [
      ...data.established.map((item) => ({ ...item, category: "established" })),
      ...data.growing.map((item) => ({ ...item, category: "growing" })),
      ...data.opportunity.map((item) => ({ ...item, category: "opportunity" })),
    ];
  }, [data]);

  return (
    <>
      <Typography
        variant="h5"
        sx={{
          mt: 1,
          mb: 1
        }}>
        <Box sx={{ display: "flex" }}>
          Top Countries
          <Box
            sx={{
              display: "flex",
              alignItems: "center"
            }}>
            <Tooltip title={tooltip} arrow>
              <IconButton sx={{ width: 30, height: 30 }}>
                <Iconify icon={"iconoir:question-mark-circle"} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Typography>
      <Grid container sx={{ flexDirection: "column" }}>
        {combinedData.map((each, index) => {
          if (each.id == "null") return null;
          if (index > 4) return null;
          return (
            <Grid  sx={{ height: 42, mb: 2 }} key={index}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mt: 2,
                }}
              >
                <ReactCountryFlag
                  countryCode={each.id}
                  svg
                  style={{
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <Typography
                  sx={{
                    fontSize: 14,
                    lineHeight: "20px",
                    fontWeight: 500,
                    ml: 2,
                    mr: 1,
                  }}
                >
                  {each.id}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-end",
                  ml: "auto",
                }}
              >
                <LinearProgress
                  sx={{
                    height: 10,
                    width: { xs: "100%", md: 215 },
                    borderRadius: 0,
                    "& .MuiLinearProgress-bar": { borderRadius: 0 },
                  }}
                  variant="determinate"
                  value={(each.value / combinedData[0].value) * 100}
                />
                <Typography
                  sx={{
                    fontSize: 14,
                    lineHeight: "20px",
                    fontWeight: 500,
                    ml: 2,
                    position: "relative",
                    top: "5px",
                  }}
                >
                  {each.value.toLocaleString()}
                </Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
}
